import { api } from './../../api.js';

import axios from 'axios';

const state = {
  current_program: ""
};

const getters = {
  getCurrentProgram: state => {
    return state.current_program;
  }
};

const mutations = {
  setCurrentProgram: (state, program) => {
    state.current_program = program;
  }
};

const actions = {
  getCourses: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      var params = {
        filters: data.filters
      };

      api
        .get("admin/courses", params)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  getDrafts: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      var params = {
        filters: data.filters
      };

      api
        .get("admin/drafts", params)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  getCourse: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/courses/" + data.id, data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  getDraft: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/drafts/" + data.id, data)
        .then(res => {
          commit("setCurrentProgram", res.data.data);
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  getCompletedPrograms: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/drafts/completed", data)
        .then(res => {
          commit("setCurrentProgram", res.data.data);
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  createCourse: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/courses", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  createDraft: function({ commit }, data) {
    console.log("????");
    return new Promise((resolve, reject) => {
      api
        .post("admin/drafts", data)
        .then(res => {
          console.log(res);
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  createCourseFull: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/courses/full", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  createDraftFull: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/drafts/full", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  createCourseShopify: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/drafts/" + data.id + "/checkout", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  editCourse: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .patch("admin/courses/" + data.id, data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  editDraft: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .patch("admin/drafts/" + data.id, data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  deleteCourse: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .delete("admin/courses/" + data.id, data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  duplicateCourse: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/courses/" + data.id + "/duplicate", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  duplicateModule: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/modules/" + data.id + "/clone", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  duplicateModuleV2: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/modules/" + data.id + "/clone-v2", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getCourseModules: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/courses/" + data.id + "/modules", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  getCourseOrganizations: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/courses/" + data.id + "/organizations", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  addProviderToCourse: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/courses/" + data.id + "/add-provider", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  addProviderToCourses: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
       .post("admin/providers/" + data.provider_id + "/organization/" + data.organization_id + "/add-courses", data.filters)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  addOrganizationToCourse: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/courses/" + data.id + "/add-organization", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  addModuleToCourse: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/courses/" + data.id + "/add-module", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  addModuleToDraft: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/drafts/" + data.id + "/add-module", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  addCustomModuleToDraft: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/drafts/" + data.course_id + "/add-custom-module", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  toggleQuizModule: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post(
          "admin/drafts/" +
            data.id +
            "/module/" +
            data.module_id +
            "/quiz/toggle",
          data
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getCourseProviderMessages: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/courses/" + data.id + "/messages/" + data.provider_id, data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  sendMessageToCourseProvider: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post(
          "admin/courses/" + data.id + "/messages/" + data.provider_id,
          data
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteProviderFromCourse: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .delete("admin/courses/" + data.id + "/delete-provider", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deactiveProviderFromProgram: function ({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.post("admin/courses/" + data.id + "/deactivate-provider", data)
        .then(res => {
        resolve(res)
        }).catch(error => {
          reject(error);
      })
    })
  },
  deleteProviderFromProgram: function ({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.post("admin/courses/" + data.id + "/deactivate-provider", data)
        .then(res => {
        resolve(res)
        }).catch(error => {
          reject(error);
      })
    })
  },
  updateCourseImage: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/courses/" + data.id + "/update-img", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getCourseProviderProgress: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/courses/" + data.id + "/progress/" + data.provider_id, data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  simulateLessonCompletion: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post(
          `admin/fake/programs/${data.course_id}/modules/${data.module_id}/lessons/${data.lesson_id}/complete`,
          data
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  markCourseProviderLessonCompleted: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post(
          "admin/courses/" +
            data.id +
            "/progress/" +
            data.provider_id +
            "/completed/" +
            data.lesson_id,
          data
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  sendCourseBulkMessage: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/courses/" + data.id + "/messages/bulk", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  bulkDueDate: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/courses/" + data.id + "/due-date/bulk", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  markCourseAsCompletedBulk: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/courses/" + data.id + "/completed/bulk", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  markCourseAsCompleted: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post(
          "admin/courses/" + data.id + "/completed/" + data.provider_id,
          data
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteModuleCourse: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .delete(
          "admin/courses/" + data.id + "/delete-module/" + data.module_id,
          data
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  generateCourseReport: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("downloads/reports/course-completion", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  generateCourseReportDownloads: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("downloads/reports/course-completion-urls", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  changeModuleOrder: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post(
          "admin/courses/" + data.id + "/change-module-order/" + data.module_id,
          data
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  sendCertificate: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post(
          "admin/courses/" + data.id + "/certificate/" + data.provider_id,
          data
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getCertificatesURL: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/courses/" + data.id + "/certificates", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  setCanDownloadCertificate: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/courses/" + data.id + "/can-download-certificate", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  generateCourseReportByDate: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/courses/" + data.id + "/download-report-dates", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateCourseDueDate: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .put(
          "admin/providers/" +
            data.id +
            "/organization/" +
            data.organization_id +
            "/course/" +
            data.course_id,
          {
            due_date: data.filters.due_date,
            starting_date: data.filters.starting_date
          }
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  publishCourse: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/courses/" + data.id + "/publish/", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  unpublishCourse: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/courses/" + data.id + "/unpublish/", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  updateIntegrationData: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/courses/" + data.id + "/update-meta-integration-data/", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  downloadCatalog: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("downloads/courses/" + data.id + "/catalog", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  downloadProgramsAllZip: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("downloads/organizations/" + data.id + "/course-catalog", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  }
};

export default {
	state,
	actions,
	getters,
	mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/CourseModule.js